// reference: https://emailregex.com/
export const emailValidationRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Code postal canadien.
 *
 * @example H5A1K6 // valide
 * @example H5A 1K6 // valide avec un espace
 * @example H5A-1K6 // valide avec un trait d'union
 * @example Z5A1K6 // non valide, format est bon mais lettre non valide injectée
 * @example HBA1K6 // non valide, format invalide
 *
 * @see https://www.canadapost-postescanada.ca/cpc/en/support/articles/addressing-guidelines/postal-codes.page
 */
export const postalCodeValidationRegex = /^(?=[^dfioquz\d\s])[A-Za-z]\d(?=[^dfioqu\d\s])[A-Za-z][-\s]?\d(?=[^dfioqu\d\s])[A-Za-z]\d$/i;

/**
 * Numéro de téléphone nord américain, excluant l'indicatif de pays.
 * Autorise des parenthèses facultatives autour du code régional ainsi que des espaces et points pour séparer
 * les différentes parties du numéro. Un format pour les liens est supporté avec `;[0-9]` à la fin du numéro
 *
 * @example 555-555-5555 // valide
 * @example 555.555.5555 // valide
 * @example 555 555 5555 // valide
 * @example (555)555 5555 // valide
 * @example (555)-555-5555 // valide
 * @example 5555555555 // valide
 * @example 5555555555;5 // valide
 *
 */
export const phoneNumberValidationRegex = /^1?[().\-\W]?([0-9]{3})[().\-\W]{0,2}([0-9]{3})[().\-\W]?([0-9]{4})(?:;([0-9]))?$/;

/**
 * Validation simple du format de l'heure sous la forme `<heure>:<minutes>' (avec des deux-points).
 * Ne prend pas en charge les secondes (pas besoin).
 *
 * @example 14:00 // valide
 * @example 00:00 // valide
 * @example 14:1  // invalide, manque un chiffre
 * @example 14h1_ // invalide, caractère invalide (manque un chiffre)
 * @example 14h00 // invalide, deux-points obligatoire
 */
export const timeFormatValidationRegex = /^\d{2}:\d{2}$/;
